<template>
  <v-container fluid>
    <v-row>
      <v-col cols="4" class="overflow-y-auto">
        <v-container v-if="loading" class="text-center">
          <v-progress-circular
              indeterminate
              color="primary"
          ></v-progress-circular>
        </v-container>
        <v-card v-else flat height="90vh">
          <v-card-actions class="pa-0">
            <v-switch v-model="filters.enabled" dense label="已启用" class="mr-4"/>
            <v-text-field v-model="filters.search" label="输入名称进行筛选" hide-details dense clearable/>
          </v-card-actions>
          <v-divider/>
          <v-treeview
              ref="tree"
              dense
              hoverable
              activatable
              transition
              return-object
              item-key="key"
              item-text="name"
              :items="items"
              :active.sync="actives"
              :search="filters.search"
          >
            <template v-slot:prepend="{ item }">
              <v-icon v-if="item.type === 'market'">
                mdi-earth
              </v-icon>
              <v-icon v-else-if="item.type === 'store'">
                mdi-store
              </v-icon>
              <v-icon color="primary" v-else-if="item.type === 'sku' && item.enabled">
                mdi-clock-check
              </v-icon>
              <v-icon v-else>
                mdi-cube-outline
              </v-icon>
            </template>
          </v-treeview>

        </v-card>
      </v-col>
      <v-divider vertical></v-divider>
      <v-col class="overflow-y-auto">
        <request-record :selected="selected"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import RequestRecord from "@/page/Request/RequestRecord";

export default {
  name: "RequestManager",
  components: {RequestRecord},
  computed: {
    selected() {
      return this.actives.length ? this.actives[this.actives.length - 1] : {}
    },

  },
  data() {
    return {
      loading: true,
      items: [],
      actives: [],
      filters: {
        enabled: false,
        search: null,
      }
    }
  },
  methods: {
    getData() {
      this.loading = true
      this.$axios.get('/products/tree', {params: {enabled: this.filters.enabled}}).then(res => {
        this.items = res.data
        this.loading = false
        console.debug('获得的节点数据: ', res.data)
      })
    },
    /*handleSearch(input) {
      if (input) {
        this.$refs.tree.updateAll(true)
      } else {
        this.$refs.tree.updateAll(false)
      }
    }*/
  },
  mounted() {
    this.getData()
  },
  watch: {
    'filters.enabled': function () {
      this.filters.search = null
      this.getData()
    }
  }
}
</script>

<style scoped>
</style>